import { render, staticRenderFns } from "./KakuShinKamiPreview.vue?vue&type=template&id=64fd7c72&scoped=true&"
import script from "./KakuShinKamiPreview.vue?vue&type=script&lang=js&"
export * from "./KakuShinKamiPreview.vue?vue&type=script&lang=js&"
import style0 from "./KakuShinKamiPreview.vue?vue&type=style&index=0&id=64fd7c72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd7c72",
  null
  
)

export default component.exports